/* JHERR · Detalles del carrito lateral y de la ficha de producto (estilos en assets/jherr-plus.css).
   1) Carrito: el descuento de cada reloj se muestra como etiqueta (nombre + monto).
   2) Carrito: al activar o quitar el envoltorio de regalo aparece un aviso con el monto y el total
      del botón "Finalizar compra" destella, para que se note que el precio cambió.
      El envoltorio sigue oculto en la lista del carrito.
   3) Ficha: un video de la galería se pausa al deslizar a otra foto y sigue desde el mismo punto
      al volver (si estaba reproduciéndose).
   4) Carrito: al agregar un reloj con grabado láser aparece el mismo aviso que con el envoltorio
      ("+ S/ 60 · Grabado láser") y el total del botón destella. */
(function () {
  'use strict';
  if (window.__jhPlus) return;
  window.__jhPlus = true;

  var TAG_SVG = '<svg class="jh-disc__icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.3"/></svg>';
  var GIFT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';

  /* 1) Etiqueta de descuento por reloj */
  function discounts(root) {
    var els = (root || document).querySelectorAll('.cart__item-price-col small.cart__discount:not([data-jh-disc])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-jh-disc', '1');
      var txt = el.textContent.replace(/\s+/g, ' ').trim();
      var m = txt.match(/^(.*?)\s*\((-[^)]+)\)$/);
      if (!m) return;
      el.innerHTML = TAG_SVG + '<span class="jh-disc__t"></span><span class="jh-disc__a"></span>';
      el.querySelector('.jh-disc__t').textContent = m[1];
      el.querySelector('.jh-disc__a').textContent = m[2].replace(/^-\s*/, '-');
    });
  }

  /* 2) Envoltorio de regalo: aviso y destello del total */
  function subtotalText() {
    var s = document.querySelector('#CartDrawer [data-subtotal]') || document.querySelector('[data-subtotal]');
    return s ? s.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function bump() {
    var btn = document.querySelector('#CartDrawer .btn.cart__checkout');
    if (!btn) return;
    btn.classList.remove('jh-total-bump');
    void btn.offsetWidth;
    btn.classList.add('jh-total-bump');
    setTimeout(function () { btn.classList.remove('jh-total-bump'); }, 1400);
  }
  function chip(on, price, svg, onLabel, offLabel) {
    var btn = document.querySelector('#CartDrawer .btn.cart__checkout');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    if (!r.width) return;
    var old = document.querySelector('.jh-gw-chip');
    if (old) old.remove();
    var c = document.createElement('span');
    c.className = 'jh-gw-chip' + (on ? '' : ' jh-gw-chip--off');
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = (svg || GIFT_SVG) + '<span></span>';
    c.lastChild.textContent = (on ? '+ ' : '− ') + (price ? price + ' · ' : '') + (on ? (onLabel || 'Envoltorio de regalo') : (offLabel || 'Sin envoltorio'));
    c.style.top = Math.max(8, r.top - 18) + 'px';
    c.style.right = Math.max(8, window.innerWidth - r.right + 12) + 'px';
    document.body.appendChild(c);
    setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 2300);
  }
  var live = document.createElement('div');
  live.setAttribute('aria-live', 'polite');
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
  var pending = null;
  function watch() {
    var started = Date.now();
    (function loop() {
      if (!pending) return;
      var now = subtotalText();
      if (now && now !== pending.before) {
        pending = null;
        bump();
        if (!live.parentNode) document.body.appendChild(live);
        live.textContent = 'Nuevo total: ' + now;
        return;
      }
      if (Date.now() - started > 6000) { pending = null; return; }
      setTimeout(loop, 120);
    })();
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'giftwrap-toggle') return;
    var on = e.target.checked;
    var row = e.target.closest('.cart-upsell-toggle');
    var price = '';
    if (row) {
      var spans = row.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        var tx = spans[i].textContent.replace(/\s+/g, ' ').trim();
        if (!spans[i].children.length && /\d/.test(tx)) { price = tx; break; }
      }
      row.classList.remove('jh-gw-on');
      void row.offsetWidth;
      if (on) row.classList.add('jh-gw-on');
    }
    chip(on, price);
    pending = { before: subtotalText() };
    watch();
  }, true);

  /* 4) Grabado láser: aviso al agregarlo (se detecta comparando el carrito antes y después).
     Espera a que el carrito lateral termine de abrir (posición quieta ~0,4 s) para que se vea. */
  var PEN_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M14 6l4 4"/></svg>';
  var engrLast = null;
  function isEngr(it) {
    var t = ((it.product_title || '') + ' ' + (it.product_type || '')).toLowerCase();
    return /grabado|fotograbado/.test(t) && !/envoltorio/.test(t);
  }
  function engrSum(cart) {
    var r = { q: 0, p: 0 };
    (cart.items || []).forEach(function (it) { if (isEngr(it)) { r.q += it.quantity; r.p += it.final_line_price; } });
    return r;
  }
  function soles(c) { return 'S/ ' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function whenDrawerReady(fn) {
    var tries = 0, lastX = null, still = 0;
    (function loop() {
      var btn = document.querySelector('#CartDrawer .btn.cart__checkout');
      var r = btn && btn.getBoundingClientRect();
      var x = r && r.width && r.right <= window.innerWidth + 1 ? r.left : null;
      still = (x !== null && lastX !== null && Math.abs(x - lastX) < 1) ? still + 1 : 0;
      lastX = x;
      if (still >= 4) { fn(); return; }
      if (++tries < 60) setTimeout(loop, 100);
    })();
  }
  function checkEngr() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var now = engrSum(cart);
        if (engrLast && now.q > engrLast.q) {
          var added = now.p - engrLast.p;
          whenDrawerReady(function () { chip(true, added > 0 ? soles(added) : '', PEN_SVG, 'Grabado láser'); bump(); });
        }
        engrLast = now;
      })
      .catch(function () {});
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) {
        p.then(function () { setTimeout(checkEngr, 250); }, function () {});
      }
      return p;
    };
  }

  /* 3) Videos de la galería */
  function post(frame, action) {
    try {
      var src = frame.getAttribute('src') || '';
      if (/youtube/.test(src)) {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: action === 'pause' ? 'pauseVideo' : 'playVideo', args: [] }), '*');
      } else if (/vimeo/.test(src)) {
        frame.contentWindow.postMessage(JSON.stringify({ method: action }), '*');
      }
    } catch (e) {}
  }
  function prepFrame(frame) {
    var src = frame.getAttribute('src') || '';
    if (/youtube/.test(src) && !/enablejsapi=1/.test(src)) {
      frame.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'enablejsapi=1');
    }
  }
  function videos() {
    var track = document.querySelector('[data-jh-track]');
    if (!track || track.__jhVid || !('IntersectionObserver' in window)) return;
    var slides = track.querySelectorAll('[data-jh-slide]');
    var withVideo = Array.prototype.filter.call(slides, function (s) { return s.querySelector('[data-jh-video]'); });
    if (!withVideo.length) return;
    track.__jhVid = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var slide = en.target;
        var v = slide.querySelector('video');
        var f = slide.querySelector('iframe');
        if (en.intersectionRatio < 0.5) {
          if (v && !v.paused) { v.pause(); slide.__jhResume = true; }
          if (f) post(f, 'pause');
        } else if (en.intersectionRatio >= 0.6 && slide.__jhResume) {
          slide.__jhResume = false;
          if (v) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        }
      });
    }, { root: track, threshold: [0, 0.5, 0.6, 1] });
    withVideo.forEach(function (s) { io.observe(s); });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IFRAME') prepFrame(n);
          else Array.prototype.forEach.call(n.querySelectorAll ? n.querySelectorAll('iframe') : [], prepFrame);
        });
      });
    }).observe(track, { childList: true, subtree: true });
    /* Si el visitante lo pausó a mano antes de deslizar, no se reanuda solo al volver
       (al deslizar solo se marca para reanudar si estaba reproduciéndose). */
  }

  function init() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      discounts(drawer);
      new MutationObserver(function () { discounts(drawer); }).observe(drawer, { childList: true, subtree: true });
    }
    videos();
    checkEngr();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();